import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { UntypedFormControl } from '@angular/forms';
import { Moment } from 'moment';
import { MatDatepicker } from '@angular/material/datepicker';
import { DateRange } from '../../core/models/date-range';
import {TestKey} from '@angular/cdk/testing';
import {TextKeys} from '../../core/i18n/text-keys';
import {TIMEZONE} from '../../core/services/language.service';

const MY_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-month-selection',
  templateUrl: './month-selection.component.html',
  styleUrls: ['./month-selection.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  ],
})
export class MonthSelectionComponent implements OnInit, OnDestroy {
  @Input() defaultDate: DateRange;
  @Output() monthSelectionChanged = new EventEmitter<DateRange>();

  date: UntypedFormControl;
  texts = TextKeys;
  protected readonly TestKey = TestKey;
  protected readonly TextKeys = TextKeys;

  constructor() {}

  ngOnInit() {
    if(this.defaultDate){
      this.date = new UntypedFormControl(moment.tz(this.defaultDate.end, TIMEZONE))
    }else{
      this.date = new UntypedFormControl(moment.tz(moment(), TIMEZONE))
    }
  }

  ngOnDestroy(): void {
  }

  onChange(){
    this.monthSelectionChanged.emit(this.getDateRange());
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
    this.onChange();
  }

  chosenMonthHandler(
    normalizedMonth: Moment,
    datepicker: MatDatepicker<Moment>
  ) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
    this.onChange();
  }

  getDateRange(): DateRange {
    return {
      start: moment.tz(this.date.value, TIMEZONE).startOf('month').format(),
      end: moment.tz(this.date.value, TIMEZONE).endOf('month').format(),
    } as DateRange;
  }

  disable() {
    this.date.disable();
  }

  enable() {
    this.date.enable();
  }

  previousMonth(event: Event) {
    event.stopImmediatePropagation();
    this.date.setValue(this.date.value.subtract(1, 'month'));
    this.onChange();
  }

  nextMonth(event: Event) {
    event.stopImmediatePropagation();
    this.date.setValue(this.date.value.add(1, 'month'));
    this.onChange();
  }


}
